var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3259_558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.37539 13.5421C9.77367 14.2563 10.3345 14.8667 11.0126 15.3238C11.6906 15.781 12.4668 16.0721 13.2782 16.1735C14.0897 16.2749 14.9136 16.1839 15.6833 15.9077C16.453 15.6315 17.1469 15.1779 17.7087 14.5837L21.8754 10.4171C22.8423 9.45012 23.3855 8.13867 23.3855 6.77122C23.3855 5.40377 22.8423 4.09232 21.8754 3.12539C20.9085 2.15845 19.597 1.61523 18.2296 1.61523C16.8621 1.61523 15.5507 2.15845 14.5837 3.12539L12.5004 5.20872M15.6254 11.4587C15.2271 10.7445 14.6662 10.1341 13.9882 9.67694C13.3102 9.21978 12.534 8.9287 11.7225 8.82727C10.9111 8.72584 10.0872 8.81691 9.31746 9.0931C8.54775 9.36929 7.85389 9.82285 7.29205 10.4171L3.12539 14.5837C2.15845 15.5507 1.61523 16.8621 1.61523 18.2296C1.61523 19.597 2.15845 20.9085 3.12539 21.8754C4.09232 22.8423 5.40377 23.3855 6.77122 23.3855C8.13867 23.3855 9.45012 22.8423 10.4171 21.8754L12.5004 19.7921",
    stroke: "#367FFF",
    strokeWidth: 2.58333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3259_558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.a71d2246a693ae27f0487169be87a81c.svg";
export { ForwardRef as ReactComponent };